export default __webpack_public_path__ + "static/media/W51Living3.97f134c4.jpg";